/**
 *
 */
export enum MeterNodeType {
    METER = "meter",
}